import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { CartProvider } from "./contexts/CartContext";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<CartProvider data-id="element-406" data-mp="218wf930448bi">
      <App data-id="element-407" data-mp="269amiitw3e8h" />
    </CartProvider>);
}